import { FC } from 'react';
import { ListItemIcon, ListItemText } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { ClockTimeArowLeft } from '@vy/ui-design-system';
import { useDialog } from '../../../../../hooks/use-dialog';
import { CreatePhaseDialog } from '../../ContractContent/components/CreatePhaseDialog';
type MenuItemRevisionProps = {
  contractId: string;
  contractStartDate: Date;
  contractEndDate?: Date;
  disabled?: boolean;
};

export const MenuItemReviseContract: FC<MenuItemRevisionProps> = ({
  contractId,
  contractStartDate,
  contractEndDate,
  disabled,
}) => {
  const {
    isDialogOpen: isCreatePhaseDialogOpen,
    handleOpen: handleCreatePhaseDialogOpen,
    handleClose: handleCreatePhaseDialogClose,
  } = useDialog();

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <MenuItem disabled={disabled} onClick={handleCreatePhaseDialogOpen}>
        <ListItemIcon>
          <ClockTimeArowLeft />
        </ListItemIcon>
        <ListItemText>Revise</ListItemText>
      </MenuItem>

      <CreatePhaseDialog
        isDialogOpen={isCreatePhaseDialogOpen}
        handleClose={handleCreatePhaseDialogClose}
        contractStartDate={contractStartDate}
        contractEndDate={contractEndDate}
        contractId={contractId}
        dialogTitle="Update contract terms"
        dialogDescription="Create a contract version with updated products and prices"
        dateInputLabel="Changes effective as of:"
        nameInputLabel="Name this version (Optional)"
      />
    </div>
  );
};
